import usePageMeta from "@/hooks/usePageMeta";

const stoneOptions = [
  { n: 1, src: "/images/preview-stones/stone_1.jpg", label: "Pale pebbles under clear, still water" },
  { n: 2, src: "/images/preview-stones/stone_2.jpg", label: "Smooth stones beneath clear rippling water" },
  { n: 3, src: "/images/preview-stones/stone_3.jpg", label: "Soft pastel stones under clean water" },
  { n: 4, src: "/images/preview-stones/stone_4.jpg", label: "Green rocks in clear teal shallows" },
  { n: 5, src: "/images/preview-stones/stone_5.jpg", label: "Dark stones beneath still water" },
  { n: 6, src: "/images/preview-stones/stone_6.jpg", label: "Stones through shallow water, soft light" },
  { n: 7, src: "/images/preview-stones/stone_7.jpg", label: "Wet stones and a fallen leaf, close-up" },
  { n: 8, src: "/images/preview-stones/stone_8.jpg", label: "A shoreline of stones under turquoise water" },
  { n: 9, src: "/images/preview-stones/stone_9.jpg", label: "A tall balance of stones by blue water" },
  { n: 10, src: "/images/preview-stones/stone_10.jpg", label: "A quiet cairn on a forest shore" },
  { n: 11, src: "/images/preview-stones/stone_11.jpg", label: "Dark stones stacked in a gentle stream" },
  { n: 12, src: "/images/preview-stones/stone_12.jpg", label: "A small stack on a soft blue shore" },
  { n: 13, src: "/images/preview-stones/stone_13.jpg", label: "Two stones balanced against a wide sky" },
  { n: 14, src: "/images/preview-stones/stone_14.jpg", label: "Four stones in still water at dawn" },
  { n: 15, src: "/images/preview-stones/stone_15.jpg", label: "Smooth rocks along silky evening water" },
  { n: 16, src: "/images/preview-stones/stone_16.jpg", label: "Dark pebbles at a twilight shore" },
];

const handsOptions = [
  { n: "H1", src: "/images/preview-hands/hands_1.jpg", label: "Hands clasped on the couch, therapist listening nearby" },
  { n: "H2", src: "/images/preview-hands/hands_2.jpg", label: "Folded hands resting on her lap — warm and still" },
  { n: "H3", src: "/images/preview-hands/hands_3.jpg", label: "Open hands across the table, soft knit" },
  { n: "H4", src: "/images/preview-hands/hands_4.jpg", label: "Seated in thought, hands clasped — moody and quiet" },
  { n: "H5", src: "/images/preview-hands/hands_5.jpg", label: "Mid-conversation, hands speaking too" },
  { n: "H6", src: "/images/preview-hands/hands_6.jpg", label: "Black & white: hands folded on the lap" },
  { n: "H7", src: "/images/preview-hands/hands_7.jpg", label: "Clasped hands and a watch, close and calm" },
  { n: "H8", src: "/images/preview-hands/hands_8.jpg", label: "Hands folded in a denim jacket — quiet strength" },
  { n: "H9", src: "/images/preview-hands/hands_9.jpg", label: "Two people's hands clasped together" },
  { n: "H10", src: "/images/preview-hands/hands_10.jpg", label: "Hands held together, raised in support" },
  { n: "H11", src: "/images/preview-hands/hands_11.jpg", label: "Holding hands on the couch, close-up" },
  { n: "H12", src: "/images/preview-hands/hands_12.jpg", label: "A gentle handhold across the couch" },
  { n: "H13", src: "/images/preview-hands/hands_13.jpg", label: "Hands reaching for each other, supported" },
  { n: "H14", src: "/images/preview-hands/hands_14.jpg", label: "Two hands gently holding, natural light" },
  { n: "H15", src: "/images/preview-hands/hands_15.jpg", label: "Clasped hands catching the light" },
  { n: "H16", src: "/images/preview-hands/hands_16.jpg", label: "Sitting cross-legged on the floor, hands resting" },
];

const couchOptions = [
  { n: "K1", src: "/images/preview-couch/couch_1.jpg", label: "Couple on the couch with therapist — warm and bright" },
  { n: "K2", src: "/images/preview-couch/couch_2.jpg", label: "Therapist guiding the conversation, plant-filled room" },
  { n: "K3", src: "/images/preview-couch/couch_3.jpg", label: "A session in a bright modern office" },
  { n: "K4", src: "/images/preview-couch/couch_4.jpg", label: "Over the therapist's shoulder — couple on the couch" },
  { n: "K5", src: "/images/preview-couch/couch_5.jpg", label: "A tense moment held with warmth — soft beige room" },
  { n: "K6", src: "/images/preview-couch/couch_6.jpg", label: "Holding hands on the couch during a session" },
  { n: "K7", src: "/images/preview-couch/couch_7.jpg", label: "Cozy session among bookshelves and plants" },
  { n: "K8", src: "/images/preview-couch/couch_8.jpg", label: "A hopeful smile mid-session" },
  { n: "K9", src: "/images/preview-couch/couch_9.jpg", label: "Couple on a gray couch, minimal bright room" },
  { n: "K10", src: "/images/preview-couch/couch_10.jpg", label: "Couple and therapist in an airy white room" },
  { n: "K11", src: "/images/preview-couch/couch_11.jpg", label: "Talking it through while the therapist listens" },
  { n: "K12", src: "/images/preview-couch/couch_12.jpg", label: "A warm conversation on the couch at home" },
  { n: "K13", src: "/images/preview-couch/couch_13.jpg", label: "Close and talking on the couch at home" },
  { n: "K14", src: "/images/preview-couch/couch_14.jpg", label: "An honest conversation, face to face" },
  { n: "K15", src: "/images/preview-couch/couch_15.jpg", label: "Facing each other on a rust-colored couch" },
  { n: "K16", src: "/images/preview-couch/couch_16.jpg", label: "An expressive conversation over water glasses" },
];

const individualOptions = [
  { n: "I1", src: "/images/preview-ind/ind_1.jpg", label: "One-on-one session in a bright, airy office" },
  { n: "I2", src: "/images/preview-ind/ind_2.jpg", label: "Over the therapist's shoulder — client in an armchair" },
  { n: "I3", src: "/images/preview-ind/ind_3.jpg", label: "Relaxed session in a bright modern room" },
  { n: "I4", src: "/images/preview-ind/ind_4.jpg", label: "Client on the couch, warm brick and soft light" },
  { n: "I5", src: "/images/preview-ind/ind_5.jpg", label: "Therapist quietly writing — moody and warm" },
  { n: "I6", src: "/images/preview-ind/ind_6.jpg", label: "Close-up: clasped hands and the therapist's notebook" },
  { n: "I7", src: "/images/preview-ind/ind_7.jpg", label: "Conversation in a book-lined office, warm tones" },
  { n: "I8", src: "/images/preview-ind/ind_8.jpg", label: "Two women in session, bright and calm" },
  { n: "I9", src: "/images/preview-ind/ind_9.jpg", label: "Close-up: hands resting, a quiet moment (current Individual hero)" },
  { n: "I10", src: "/images/preview-ind/ind_10.jpg", label: "Classic office by a tall window, old-world warmth" },
  { n: "I11", src: "/images/preview-ind/ind_11.jpg", label: "A hard moment held with care — rich warm tones" },
  { n: "I12", src: "/images/preview-ind/ind_12.jpg", label: "Coffee and a book by a rain-streaked window" },
  { n: "I13", src: "/images/preview-ind/ind_13.jpg", label: "Journal and coffee on a window seat by the sea" },
  { n: "I14", src: "/images/preview-ind/ind_14.jpg", label: "Writing by the window, city in soft focus" },
  { n: "I15", src: "/images/preview-ind/ind_15.jpg", label: "Empty armchair in a sunlit, plant-filled room" },
  { n: "I16", src: "/images/preview-ind/ind_16.jpg", label: "A warm corner — armchair, lamp and art by the window" },
];

const couplesOptions = [
  { n: "C1", src: "/images/preview/opt_1.jpg", label: "On the couch, distant and tense" },
  { n: "C2", src: "/images/preview/opt_2.jpg", label: "On the couch in honest discussion" },
  { n: "C3", src: "/images/preview/opt_3.jpg", label: "Relaxed on a leather sofa, bright modern room" },
  { n: "C4", src: "/images/preview/opt_4.jpg", label: "Laughing together on the couch" },
  { n: "C5", src: "/images/preview/opt_5.jpg", label: "Black & white: couch from behind, café light" },
  { n: "C6", src: "/images/preview/opt_6.jpg", label: "A therapy-style conversation" },
  { n: "C7", src: "/images/preview/opt_7.jpg", label: "Couples session in progress" },
  { n: "C8", src: "/images/preview/opt_8.jpg", label: "Talking at a bright office table" },
  { n: "C9", src: "/images/preview/opt_9.jpg", label: "Curled up in an armchair, alone" },
  { n: "C10", src: "/images/preview/opt_10.jpg", label: "Warm conversation by a bright window" },
  { n: "C11", src: "/images/preview/opt_11.jpg", label: "Walking a misty autumn road" },
  { n: "C12", src: "/images/preview/opt_12.jpg", label: "Rainy old-town street" },
  { n: "C13", src: "/images/preview/opt_13.jpg", label: "Running through the rain, city street" },
  { n: "C14", src: "/images/preview/opt_14.jpg", label: "Evening alley with string lights" },
  { n: "C15", src: "/images/preview/opt_15.jpg", label: "Under one umbrella on a wet park path" },
  { n: "C16", src: "/images/preview/opt_16.jpg", label: "Sharing an umbrella at a rainy crosswalk" },
  { n: "C17", src: "/images/preview/opt_17.jpg", label: "Walking the rainy seaside promenade" },
  { n: "C18", src: "/images/preview/opt_18.jpg", label: "Crossing a rainy plaza" },
  { n: "C19", src: "/images/preview/opt_19.jpg", label: "Black & white: holding hands, foggy crosswalk" },
  { n: "C20", src: "/images/preview/opt_20.jpg", label: "Holding hands down a rainy cobblestone alley" },
];

const Grid = ({ options, prefix }) => (
  <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
    {options.map((o) => (
      <div key={o.n} data-testid={`${prefix}-option-${o.n}`}>
        <div className="relative overflow-hidden rounded-xl border border-forest-800/10">
          <img src={o.src} alt={o.label} loading="lazy" className="w-full h-72 object-cover" />
          <span className="absolute top-4 left-4 min-w-11 h-11 px-2 rounded-full bg-forest-900 text-gold-400 font-serif text-xl flex items-center justify-center shadow-lg">
            {o.n}
          </span>
        </div>
        <p className="mt-3 text-sm font-medium text-forest-800">
          <span className="text-gold-600 font-serif text-lg mr-2">{o.n}.</span>
          {o.label}
        </p>
      </div>
    ))}
  </div>
);

const HeroPreview = () => {
  usePageMeta("Image Options", "Preview of image candidates.");
  return (
    <div className="bg-cream-50 min-h-screen py-16" data-testid="hero-preview-page">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <p className="eyebrow mb-4">Preview Only</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-forest-800 tracking-tight">Stones & water — new options</h1>
        <p className="mt-4 text-sage max-w-xl">
          Sixteen calm, clean candidates — smooth stones in clear water, quiet balanced stacks, and still shorelines.
          Reply with the numbers you love and where to place them (for example, the Individual Therapy hero).
        </p>
        <Grid options={stoneOptions} prefix="stone" />

        <div className="mt-24 pt-12 border-t border-forest-800/10">
          <h2 className="font-serif text-3xl sm:text-4xl text-forest-800 tracking-tight">Hands & quiet moments</h2>
          <p className="mt-3 text-sage max-w-xl">
            The sixteen close-up options. Reference these with an "H" — for example H2.
          </p>
          <Grid options={handsOptions} prefix="hands" />
        </div>

        <div className="mt-24 pt-12 border-t border-forest-800/10">
          <h2 className="font-serif text-3xl sm:text-4xl text-forest-800 tracking-tight">Couples on the couch</h2>
          <p className="mt-3 text-sage max-w-xl">
            The sixteen couch options. Reference these with a "K" — for example K6.
          </p>
          <Grid options={couchOptions} prefix="couch" />
        </div>

        <div className="mt-24 pt-12 border-t border-forest-800/10">
          <h2 className="font-serif text-3xl sm:text-4xl text-forest-800 tracking-tight">Individual therapy</h2>
          <p className="mt-3 text-sage max-w-xl">
            The sixteen individual options. Reference these with an "I" — for example I12.
          </p>
          <Grid options={individualOptions} prefix="ind" />
        </div>

        <div className="mt-24 pt-12 border-t border-forest-800/10">
          <h2 className="font-serif text-3xl sm:text-4xl text-forest-800 tracking-tight">Couples — first round</h2>
          <p className="mt-3 text-sage max-w-xl">
            The original twenty couples options. Reference these with a "C" — for example C19.
          </p>
          <Grid options={couplesOptions} prefix="couples" />
        </div>
      </div>
    </div>
  );
};

export default HeroPreview;
